<template>
  <div>
    <validation-observer ref="observer">
      <labeled-wrapper
          v-if="distribution.college === distributionCollegeTypes.PERFORMER || distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER"
          :label="$t('performer') | capitalize">
        <b-row>
          <b-col>
            <distribution-detail-field
                :label="$t('open_period_start_date') | capitalize"
                :value="distribution.openPeriodStartPerformer | date($config.DATE_FORMAT)"
            />
          </b-col>
          <b-col>
            <distribution-detail-field
                :label="$t('open_period_end_date') | capitalize"
                :value="distribution.openPeriodEndPerformer | date($config.DATE_FORMAT)"
                :edit-mode="editMode"
                ref="openPeriodEndPerformer"
                vid="openPeriodEndPerformer"
                :rules="`after:@openPeriodStartPerformer,${$config.DATE_FORMAT},1,month`"
            >
              <template v-slot:input="{ state }">
                <date-picker
                    type="date"
                    v-model="distribution.openPeriodEndPerformer"
                    :value-type="$config.ISO_DATE_FORMAT"
                    :class="{invalid: state === false}"
                    :format="$config.DATE_FORMAT"
                />
              </template>
            </distribution-detail-field>
          </b-col>
        </b-row>
      </labeled-wrapper>
      <labeled-wrapper
          v-if="distribution.college === distributionCollegeTypes.MAKER || distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER"
          :label="$t('maker') | capitalize"
          style="margin-top: 25px">
        <b-row>
          <b-col>
            <distribution-detail-field
                :label="$t('open_period_start_date') | capitalize"
                :value="distribution.openPeriodStartMaker | date($config.DATE_FORMAT)"
            />
          </b-col>
          <b-col>
            <distribution-detail-field
                :label="$t('open_period_end_date') | capitalize"
                :value="distribution.openPeriodEndMaker | date($config.DATE_FORMAT)"
                :edit-mode="editMode"
                ref="openPeriodEndMaker"
                vid="openPeriodEndMaker"
                :rules="`after:@openPeriodStartMaker,${$config.DATE_FORMAT},1,month`"
            >
              <template v-slot:input="{ state }">
                <date-picker
                    type="date"
                    v-model="distribution.openPeriodEndMaker"
                    :value-type="$config.ISO_DATE_FORMAT"
                    :class="{invalid: state === false}"
                    :format="$config.DATE_FORMAT"
                />
              </template>
            </distribution-detail-field>
          </b-col>
        </b-row>
      </labeled-wrapper>


    </validation-observer>
  </div>
</template>

<script>

import DistributionDetailField from "@/components/DistributionDetailField"
import LabeledWrapper from "../../../components/LabeledWrapper.vue"
import { ValidationObserver } from "vee-validate"
import { distributionCollegeTypes } from "@/constants"
import { distributionSectionMixin } from "@/utils/mixins"

export default {
  name: "OpenPeriodSection",
  components: { LabeledWrapper, DistributionDetailField, ValidationObserver },
  mixins: [distributionSectionMixin],
  props: {
    distribution: Object,
    editMode: Boolean,
    hasTransactions: Boolean,
    transactionsRunning: Boolean
  },
  data () {
    return {
      distributionCollegeTypes
    }
  }
}
</script>
